"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomDataPlaceholders = void 0;

var _reselect = require("reselect");

var _root = require("../root.selector");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var getCustomDataPlaceholders = (0, _reselect.createSelector)(_root.getCreateGiftState, function (createGift) {
  return createGift.placeholders.placeholders;
});
exports.getCustomDataPlaceholders = getCustomDataPlaceholders;